export default __webpack_public_path__ + "db0ef87a5e657736be961cb02b2f4c71.ttf";